export default __webpack_public_path__ + "media/images/admin/dashboard/GuideDialogImageGuide-a5aad5c508ef0331d28c0fc19f8f6f93.png";